import {
	ResponseExport,
	ResponseGraphics,
	ResponseTable,
	ResponseTableCustomLink,
	ResponseTablePLSales,
} from '../models/common-payments';
import { Head } from '../models/home';
import {
	EditPaymentLinkCustom,
	GetAllPaymentCustomLinks,
	PATHS,
	ResponseCode,
} from '../models/payment-links-custom';
import { client } from '../utils/api';
import { exportParamsConstructor, tableParamsConstructor } from '../utils/common';
import { transformDate } from '../utils/dates';
import {
	GetAllLinksCustomLinks,
	PausePaymentLinkCustomParams,
} from './../models/payment-links-custom';
import { ExportDataParams } from './../models/quick-transfer';

const getGraphicsData = async (merchantCode: string) => {
	try {
		const params = { merchant_code: merchantCode };
		const { data } = await client.get<ResponseGraphics>(PATHS.getGraphicsData, { params });
		return data;
	} catch (error: any) {
		throw error.response.data;
	}
};

const getLastPayments = async (merchantCode: string) => {
	try {
		const params = { merchant_code: merchantCode };
		const { data } = await client.get<ResponseTable>(PATHS.getLastPayments, { params });
		return data;
	} catch (error: any) {
		throw error.response.data;
	}
};

const getAllPayments = async ({ ...rest }: GetAllPaymentCustomLinks) => {
	try {
		const params = tableParamsConstructor(rest);
		const { data } = await client.get<ResponseTable>(PATHS.getAllPayments, { params });
		return data;
	} catch (error: any) {
		throw error.response.data;
	}
};

const getAllLinks = async ({ ...rest }: GetAllLinksCustomLinks) => {
	try {
		const params = tableParamsConstructor(rest);
		const { data } = await client.get<ResponseTableCustomLink>(PATHS.getAllLinks, { params });
		return data;
	} catch (error: any) {
		throw error.response.data;
	}
};

const getStatistics = async (merchantCode: string, date: Date) => {
	try {
		const params = Object();
		params.merchant_code = merchantCode;
		params.date = transformDate(date);

		const { data } = await client.get<Head>('/v1/pl-custom/payments/statistics', { params });
		return data;
	} catch (error: any) {
		throw error.response.data;
	}
};

const getExportPaymentData = async ({ ...rest }: ExportDataParams) => {
	try {
		const params = exportParamsConstructor(rest);
		const { data } = await client.get<ResponseExport>(PATHS.getExportPaymentsData, { params });
		return data;
	} catch (error: any) {
		throw error.response.data;
	}
};

//Sales services
const getStatisticsSales = async (merchantCode: string, from?: Date, to?: Date) => {
	try {
		const params = Object();
		params.merchant_code = merchantCode;
		params.from = from ? transformDate(from) : undefined;
		params.to = to ? transformDate(to) : undefined;

		const { data } = await client.get<Head>(PATHS.getStatisticsSales, { params });
		return data;
	} catch (error: any) {
		throw error.response.data;
	}
};

const getPaymentTableSales = async ({ ...rest }: GetAllPaymentCustomLinks) => {
	try {
		const params = tableParamsConstructor(rest);
		const { data } = await client.get<ResponseTablePLSales>(PATHS.getPaymentTableSales, { params });
		return data;
	} catch (error: any) {
		throw error.response.data;
	}
};

const getExportPaymentDataSales = async ({ ...rest }: ExportDataParams) => {
	try {
		const params = exportParamsConstructor(rest);
		const { data } = await client.get<ResponseExport>(PATHS.getExportPaymentsDataSales, { params });
		return data;
	} catch (error: any) {
		throw error.response.data;
	}
};

const editLinkCustom = async ({
	presession_token,
	merchant_code,
	payment_type,
	amount_type,
	name,
	order_amount,
	order_amount_min,
	order_amount_max,
	num_payments,
	end_expired_at,
	has_end_expiration_date,
	fields,
}: EditPaymentLinkCustom) => {
	try {
		const body = {
			payment_type,
			amount_type,
			name,
			order_amount,
			order_amount_min,
			order_amount_max,
			num_payments,
			end_expired_at,
			has_end_expiration_date,
			fields,
		};
		const { data } = await client.put<ResponseCode>(
			`/v1/pl-custom/${presession_token}?merchant_code=${merchant_code}`,
			body,
		);
		return data;
	} catch (error: any) {
		console.error(error);
		throw error.response.code;
	}
};

const PausePaymentLinkCustom = async ({ token, merchantCode }: PausePaymentLinkCustomParams) => {
	try {
		const { data } = await client.patch(
			`/v1/pl-custom/${token}/pause?merchant_code=${merchantCode}`,
		);
		return data;
	} catch (error: any) {
		console.error(error);
		throw error.response.code;
	}
};

const ResumePaymentLinkCustom = async ({ token, merchantCode }: PausePaymentLinkCustomParams) => {
	try {
		const { data } = await client.patch(
			`/v1/pl-custom/${token}/resume?merchant_code=${merchantCode}`,
		);
		return data;
	} catch (error) {
		console.error(error);
	}
};

const FinalizePaymentLinkCustom = async ({ token, merchantCode }: PausePaymentLinkCustomParams) => {
	try {
		const { data } = await client.patch(`/v1/pl-custom/${token}/end?merchant_code=${merchantCode}`);
		return data;
	} catch (error: any) {
		console.error(error);
		throw error.response.code;
	}
};

export const PaymentLinksCustomServices = {
	getGraphicsData,
	getLastPayments,
	getStatistics,
	getStatisticsSales,
	getAllPayments,
	getPaymentTableSales,
	getAllLinks,
	getExportPaymentData,
	getExportPaymentDataSales,
	editLinkCustom,
	PausePaymentLinkCustom,
	ResumePaymentLinkCustom,
	FinalizePaymentLinkCustom,
};
